import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadFileService {

  private baseUrl = environment.apiURL;
  // 'http://localhost:8080/ceapi/';
  //  

  constructor(private http: HttpClient) { }

  upload(file: FileList, billofladingId): Observable<HttpEvent<any>> {
    const formData: FormData = new FormData();
    Array.from(file).forEach(currentFile => {
      formData.append('files', currentFile);
    })
    
    let headers: HttpHeaders = new HttpHeaders({
      'Authorization': 'Bearer ' + localStorage.getItem("access_token"),
      'scac': JSON.parse(localStorage.getItem("user-tenant")) ? JSON.parse(localStorage.getItem("user-tenant")).scac : "prod",
    });

    // upload-multiple-ftp-files-combined
    const req = new HttpRequest('POST',
      `${this.baseUrl}secured/upload-multiple-ftp-files?billoflading-id=${billofladingId}&types=a`,
      formData, {
      reportProgress: true,
      responseType: 'json',
      headers: headers
    });

    return this.http.request(req);
  }

  getFiles(): Observable<any> {
    return this.http.get(`${this.baseUrl}/files`);
  }
}
